import languages from '@/constants/Languages';

export const sortLanguagesByMain = (languages: Language[]): Language[] => {
  return [...languages].sort((a, b) => {
    if (a.isMain === b.isMain) return 0;
    return a.isMain ? -1 : 1;
  });
};

export const getLanguageWithCode = (code: string): Language | undefined => {
  const language = languages.find((language) => {
    return language.code === code;
  });
  return language;
};

export const getMainLanguage = (
  languages: Language[],
): Language | undefined => {
  const language = languages.find((language) => {
    return language.isMain;
  });
  return language;
};

export default interface Language {
  name: string;
  code: string;
  flag?: string;
  isMain?: boolean;
}
